import React, { MouseEvent } from 'react';
import { Pagination, SearchableColumn, SortableColumn, ModalComponent, Spinner, SpinnerSmall } from '@eyesee/eyesee-hub-npm-ui';
import { projectsStore, projectsData } from '../../stores/projectsStore';
import { observer } from 'mobx-react-lite';
import ProjectRow from '../../components/ProjectsRow/ProjectsRow';
import CreateButton from '../../components/CreateButton/CreateButton';
// import Logout from './Logout.jsx';
import { useEffect } from 'react';
import DeleteModal from '../../components/DeleteModal/DeleteModal';
// import LinkPreview from './Link.jsx';

import './projects.scss';
import { projectDetailsData, projectDetailsStore } from '../../stores/projectDetailsStore';
import { useState } from 'react';

const Projects = observer(() => {
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [projectsPerPage, setProjectsPerPage] = useState<number>(20);

    // get current posts

    let indexOfLastProject = currentPage * projectsPerPage;
    let indexOfFirstProject = indexOfLastProject - projectsPerPage;
    let currentProjects = projectsData.filteredProjects.slice(indexOfFirstProject, indexOfLastProject);
    let pages = Math.ceil(projectsData.projects.length / projectsPerPage);

    useEffect(() => {
        projectsStore.fetchProjects();
    }, []);

    const onDeleteProject = (id: string, e: MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => {
        e.stopPropagation();
        projectsData.isModalVisible = true;
        projectsData.modalData = id;
    };

    const handleNewProject = () => {
        let newProject = {
            name: 'new project',
            project_id: null,
            type:'project',
            creationDate: new Date(),
            cells: [],
        }
        projectDetailsData.project = newProject;
        projectDetailsStore.saveProject()
    };
    return (
        <div id="projects">
            <ModalComponent
                hide={() => (projectsData.isModalVisible = false)}
                component={
                    <DeleteModal 
                      confirmFN={() => projectsStore.deleteProject(projectsData.modalData)} 
                      hideModal={projectsStore.hideModal} 
                      headerText={"Delete Project"}
                      contentText={"You are about to delete a project. Are you sure? "}
                      confirmButtonText={"Delete"}
                    />
                }
                isVisible={projectsData.isModalVisible}
            />

            {projectsData.state === 'loading' ? (
                <div className="table-spinner">
                    <SpinnerSmall />
                </div>
            ) : (
                <div className="projects-table">
                    <div className="table-header">
                        <></> <CreateButton onSubmit={handleNewProject} />
                    </div>
                    <table>
                        <thead>
                            <tr>
                                
                                <SearchableColumn name="title" placeholder="Project Name" onSearch={projectsStore.filterProjects} />
                                <SortableColumn
                                    children={null}
                                    title="Creation Date"
                                    onSort={projectsStore.sortBy}
                                    sortBy={() => {}}
                                    sortOrder={() => {}}
                                    name="creationDate"
                                    classes="narrow-col"
                                    sortType="number"
                                />
                                <th className="narrow-col">Test results</th>
                                <th className="narrow-col">Premium test results</th>

                            </tr>
                        </thead>

                        <tbody>
                            {currentProjects.map((project, idx) => (
                                <ProjectRow
                                    key={project.id}
                                    project={project}
                                    duplicateProject={() => projectsStore.duplicateProject(project.id)}
                                    deleteProject={(e: MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => onDeleteProject(project.id ? project.id : '', e)}
                                />
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
            <div className="projects-pagination">
                <Pagination
                    currentPageInit={1}
                    pages={pages}
                    perPage={projectsPerPage}
                    onPerPageChanged={(perPage) => setProjectsPerPage(perPage)}
                    perPageOptions={[2, 5, 10, 15, 20]}
                    setPerPage={setProjectsPerPage}
                    onCurrentPageSet={(page) => setCurrentPage(page)}
                    toggleResetCurrPage={false}
                />
            </div>
        </div>
    );
});
export default Projects;
